"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemUnitCell = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const useDebouncedState_1 = require("../../../utils/useDebouncedState");
const ItemUnitCell = (props) => {
    const [debouncedItem, setDebouncedItem] = (0, useDebouncedState_1.useDebouncedState)(props.item, props.onItemChange, 300, { leading: true });
    function handleChange(value) {
        const itemClone = (0, cloneDeep_1.default)(debouncedItem);
        itemClone.unit = value.slice(0, 20);
        setDebouncedItem(itemClone);
    }
    if (props.isResource || !debouncedItem.customized) {
        return react_1.default.createElement("span", null, debouncedItem.unit);
    }
    else {
        return (react_1.default.createElement("input", { className: "w-100", type: "text", value: debouncedItem.unit, onChange: (e) => handleChange(e.target.value), disabled: !props.editable }));
    }
};
exports.ItemUnitCell = ItemUnitCell;
